// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cyndaquil: PokeData = {
  "id": 155,
  "name": "cyndaquil",
  "height": 5,
  "weight": 79,
  "base_experience": 62,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "tackle",
    "double-edge",
    "leer",
    "ember",
    "flamethrower",
    "quick-attack",
    "smokescreen",
    "defense-curl",
    "swift",
    "flame-wheel",
    "rollout",
    "eruption",
    "overheat",
    "lava-plume",
    "flame-charge",
    "inferno",
    "burn-up"
  ],
  "moves": [
    "tackle",
    "leer",
    "ember",
    "flamethrower",
    "quick-attack",
    "eruption",
    "fire-punch",
    "morning-sun",
    "fire-ball",
    "magma-storm",
    "flare-blitz",
    "blaze-kick",
    "fire-spin"
  ],
  "evolution_chain": {
    "id": 80,
    "item": null,
    "species": [
      {
        "name": "cyndaquil",
        "order": 187,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "quilava",
        "order": 188,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 155,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 14,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "typhlosion",
        "order": 189,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 156,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 42.75,
    "speed": 65,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
